import type { CheckSummary, VerdictCode } from '@eloquor/api-contract';
import { RatingPill } from '../ratings/RatingPill';

const VERDICTS: VerdictCode[] = ['ok', 'ethicsvio', 'miscut', 'powertagged', 'unclear', 'error', 'unchecked'];

export function SummaryStrip({ summary }: { summary: CheckSummary }) {
  return (
    <div
      style={{
        display: 'flex',
        gap: 12,
        flexWrap: 'wrap',
        padding: '12px 14px',
        background: 'var(--vellum)',
        border: '1px solid var(--border)',
        borderRadius: 8,
        fontFamily: 'var(--font-mono)',
        fontSize: 12,
      }}
    >
      <span style={{ color: 'var(--fg-3)' }}>{summary.total} total</span>
      {VERDICTS.map((v) =>
        summary[v] > 0 ? (
          <span key={v} style={{ display: 'inline-flex', gap: 6, alignItems: 'center' }}>
            <RatingPill verdict={v} size="sm" /> {summary[v]}
          </span>
        ) : null
      )}
    </div>
  );
}
